import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Navigate } from 'react-router-dom';

import { So5LeaderboardType } from '@sorare/core/src/__generated__/globalTypes';
import { Img } from '@sorare/core/src/atoms/ui/Img';
import { FOOTBALL_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSeoContext } from '@sorare/core/src/contexts/seo';
import { useIsLoggedIn } from '@sorare/core/src/hooks/auth/useIsLoggedIn';

import { EarlyAccess } from 'components/landing/EarlyAccess';

import competeCardsAvif from './assets/compete/cards.avif';
import competeCards from './assets/compete/cards.png';
import competeFieldAvif from './assets/compete/field.avif';
import competeField from './assets/compete/field.jpg';
import leagueLogo from './assets/league-logo.png';
import scoutBackgroundAvif from './assets/scout/background.avif';
import scoutBackground from './assets/scout/background.jpg';
import scoutPlayersAvif from './assets/scout/players.avif';
import scoutPlayers from './assets/scout/players.png';
import social from './assets/social.jpg';
import winCardsAvif from './assets/win/cards.avif';
import winCards from './assets/win/cards.png';

const messages = defineMessages({
  metadatasTitle: {
    id: 'LaLigaLanding.metadatas.title',
    defaultMessage: 'The Global Fantasy LaLiga Game – Sorare Football',
  },
  metadatasDescription: {
    id: 'LaLigaLanding.metadatas.description',
    defaultMessage:
      'Play Sorare’s fantasy LaLiga game. Collect, buy, sell, and compete with ownable digital player cards from all 20 LaLiga football clubs to win rewards.',
  },
});

const FootballPage = () => {
  const isLoggedIn = useIsLoggedIn();
  const { formatMessage } = useIntl();
  const { setPageMetadata } = useSeoContext();

  useEffect(
    () =>
      setPageMetadata(formatMessage(messages.metadatasTitle), {
        img: social,
        description: formatMessage(messages.metadatasDescription),
      }),
    [setPageMetadata, formatMessage]
  );

  if (isLoggedIn) {
    return <Navigate to={FOOTBALL_PLAY} replace />;
  }
  return (
    <EarlyAccess
      starPlayerSlug="kylian-mbappe-lottin"
      variant="LaLigaEA_landing"
      assets={{
        scout: {
          background: {
            avif: scoutBackgroundAvif,
            pictureUrl: scoutBackground,
          },
          players: { avif: scoutPlayersAvif, pictureUrl: scoutPlayers },
        },
        compete: {
          field: {
            avif: competeFieldAvif,
            pictureUrl: competeField,
          },
          cards: { avif: competeCardsAvif, pictureUrl: competeCards },
        },
        win: {
          cards: {
            avif: winCardsAvif,
            pictureUrl: winCards,
          },
        },
      }}
      leaderboards={[
        So5LeaderboardType.IN_SEASON_SPAIN_LIMITED,
        So5LeaderboardType.IN_SEASON_SPAIN_UNIQUE,
        So5LeaderboardType.IN_SEASON_SPAIN_RARE,
      ]}
      league={<Img src={leagueLogo} alt="Laliga" width="244" height="80" />}
    />
  );
};

export default FootballPage;
